

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import Sign from './layouts/Sign.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import { inject } from '@vercel/analytics';
import Vue2Filters from 'vue2-filters'
import Vuetify from 'vuetify'
import DaySpanVuetify from 'dayspan-vuetify'



// import './plugins/click-away'

import './scss/app.scss';

Vue.use(Antd);
Vue.use(Vue2Filters)
Vue.use(Vuetify);

Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});


Vue.config.productionTip = false

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);
Vue.component("layout-sign", Sign);
inject();



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
